<div class="otp-container" [class.has-error]="hasError" [class.disabled]="disabled">
  <input
    *ngFor="let digit of digits; let i = index; trackBy: trackByIndex"
    #otpInput
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    maxlength="1"
    autocomplete="one-time-code"
    [value]="digit"
    [disabled]="disabled"
    [attr.id]="'otp-' + i"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i)"
    (keypress)="onKeyPress($event)"
    (paste)="onPaste($event)"
  />
</div>
